module.exports = __webpack_public_path__ + "img/box_bg_4.98d54130.jpg";